import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect, useLayoutEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ClearGetContractorById} from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsSlice";
import {ClearGetEmployeeSupplierByItId} from "../../../../../reduxToolkit/EmployeeProviders/EmployeeProviderSlice";
import {ClearGetContractorInfoById} from "../../../../../reduxToolkit/Contractor/ContractorSlice";
import {ClearGetSupplierInfoById} from "../../../../../reduxToolkit/Providers/providerSlice";
import {GetGenderListProvider} from "../../../../../reduxToolkit/EmployeeProviders/EmployeeProvidersApi";
import {userInfoStatus} from "../../../../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi";
import {errorMsg, isEmailFormat, isPhoneFormat, validateMinLengthTrimmed} from "../../../../../Apis/functions";
import {DeleteItemsApi} from "../../../../../reduxToolkit/Commons/CommonsApi";
import {PHOTO_PICKER_MODEL} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import defaultImage from '../../../../../assets/ImagesDefaults/ic-person.svg';
import IconPersonDefault from '../../../../../assets/ImagesDefaults/ic-person-v2.svg';
import PasswordGenerator from "../../../../../Helpers/PasswordGenerator";
import { PASSWORD_MIN_LENGTH } from "../../../../../constant/variable";
import { EXTRA_DATA } from "../../../Company/Employees/Model/Models";
import { GetHeaders } from "../../../../../reduxToolkit/headers/HeadersApi";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

export const CommonContractorCreateUpdateApp =()=>{
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('supplierId'));
    const [deleteElementShow, setDeleteElementShow] = useState(false);
    const [workShiftsList, setWorkShiftsList] = useState([]);
    const [customizedList, setCustomizedList] = useState([]);
    const { getEmployeeSupplierByItId } = useSelector((state) => state.EmployeeProviderSlice);
    const { getContractorById } = useSelector((state) => state.EmployeeContractorsSlice);
    const userInfoStatusList = useSelector((state) => state?.CompanyEmployeesSlice?.userInfoStatusList);
    const { getContractorInfoById } = useSelector((state) => state.ContractorSlice);
    const { getUserFullInformation } = useSelector((state) => state.CommonsSlice);
    const { getSupplierInfoById } = useSelector((state) => state?.providersSlice);
    const [deleteUser, setDeleteUser] = useState(false);
    const [emptyFields, setEmptyFields] = useState(false);
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [selectElementForDelete, setSelectElementForDelete] = useState([params?.id]);
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
    const [isValidDob, setIsValidDob] = useState(true);
    const [language, setLanguage] = useState('');
    const [isValidDocumentId, setIsValidDocumentId] = useState(true);
    const [isValidPassword, setIsValidPassword ] = useState(true);
    const [photoPicker, setPhotoPicker] = useState({...PHOTO_PICKER_MODEL, preview: IconPersonDefault})
    const [secretModal, setSecretModal] = useState(false);
    const [secretKey, setSecretKey] = useState(null);
    const [generatedPassword, setGeneratedPassword] = useState(null);
    const { passwordGenerator } = PasswordGenerator();
    const [disabled, setDisabled] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState([]);
    const [modified, setModified] = useState(false);
    const [extraData, setExtraData] = useState({...EXTRA_DATA});
    const [extraDataEnabled, setExtraDataEnabled] = useState(false);
    // Get headers configuration from Redux store
    const { headersList } = useSelector((state) => state.headersSlice);

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    useLayoutEffect(() => {
        window.addEventListener('message', handleLanguageChange);
        return () => {
            window.removeEventListener('message', handleLanguageChange);
            dispatch(ClearGetContractorById());
            dispatch(ClearGetEmployeeSupplierByItId());
            dispatch(ClearGetContractorInfoById());
            dispatch(ClearGetSupplierInfoById());
        };
    }, []);

    // Function to handle the message received from another window
    const handleLanguageChange = (event) => {
        // Check if the received message is of the expected type
        if (event.data && event.data.type === 'languageChange') {
            // Update the variable with the new value
            let newValue = event.data.newValue !== null ? event.data.newValue : '';
            setLanguage(newValue);
        }
    };

    useEffect(() => {
        dispatch(GetGenderListProvider());
        dispatch(userInfoStatus());
        dispatch(GetHeaders());
    }, []);


    const handleDateChange = (selectedDate, setUser) => {
        setUser((prevData) => ({
            ...prevData,
            dob: selectedDate,
        }));
    };

    const handleEmailChange = (email) => {
        validateEmail(email);
    };

    const handlePasswordChange = (password) => {
    const isValid = validateMinLengthTrimmed(password, {
        minLength: PASSWORD_MIN_LENGTH,
        allowEmpty: true
    });

    setIsValidPassword(isValid);
};


    const handlePhoneNumberChange = (phone, setUser) => {
        setUser((prevData) => ({
            ...prevData,
            phoneNumber: phone !== '' ? '+' + phone : '',
        }));
        validatePhone(phone);
    };

    const validateEmail = (email) => {
        const isValid = isEmailFormat(email);
        setIsValidEmail(isValid);
        return isValid;
    };

    const validatePhone = (phone) => {
        const isValid = isPhoneFormat(phone);
        setIsValidPhoneNumber(isValid);
        return isValid;
    };
    const validatePassword = (phone) => {
        const isValid = validateMinLengthTrimmed(phone, PASSWORD_MIN_LENGTH);
        setIsValidPassword(isValid);
        return isValid;
    };


    const reset = () => {
        setIsValidPhoneNumber(true);
        setIsValidDob(true);
        setIsValidEmail(true);
        setIsValidPassword(true);
        setIsValidDocumentId(true);
        setEmptyFields(false);
        setPhotoPicker({...PHOTO_PICKER_MODEL, preview: defaultImage});
    };

    const deleteSelectedElement = (deleteItem, tableName, url) => {
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName, body })).then((response) => {
                const success = response?.payload?.data?.success;
                const code = response?.payload?.data?.code;
                if (success === true) {
                    navigate(url);
                }else errorMsg(code);
            });
        }
    };

    return {
        t,
        contractorId,
        dispatch,
        navigate,
        DEV,
        params,
        permission,
        deleteElementShow,
        setDeleteElementShow,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        getEmployeeSupplierByItId,
        getContractorById,
        userInfoStatusList,
        getContractorInfoById,
        getUserFullInformation,
        getSupplierInfoById,
        deleteUser,
        setDeleteUser,
        emptyFields,
        setEmptyFields,
        isValidEmail,
        isValidPassword, 
        setIsValidPassword,
        setIsValidEmail,
        selectElementForDelete,
        setSelectElementForDelete,
        isValidPhoneNumber,
        setIsValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        language,
        setLanguage,
        isValidDocumentId,
        setIsValidDocumentId,
        supplierId,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        deleteSelectedElement,
        reset,
        photoPicker,
        setPhotoPicker,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        generatedPassword,
        setGeneratedPassword,
        passwordGenerator,
        disabled,
        setDisabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,
        handleStepChange,
        modified,
        setModified,
        validatePassword,
        extraData,
        setExtraData,
        headersList,
        extraDataEnabled,
        setExtraDataEnabled,
    }
}
